// The one query client of the app (decision 064): every page refreshes by
// itself. A query is asked again every ten seconds while the window is
// visible and whenever it regains focus; nothing in the app is a Refresh
// button. A hidden window (the companion in the tray, a background tab)
// asks nothing until it is shown again.

import { QueryCache, QueryClient } from "@tanstack/react-query";

import { ApiError } from "@/api";
import { reportError } from "@/lib/report";

/** How often the platform is asked again while the window is visible. */
export const PAGE_REFRESH_MS = 10_000;

export function createQueryClient(): QueryClient {
  return new QueryClient({
    // A platform failure or a network cut behind a query reaches the admin page (decision 140); a refusal with words is the page's to show.
    queryCache: new QueryCache({
      onError: (error) => {
        if (error instanceof ApiError) {
          if (error.status >= 500) reportError({ code: error.code, message: error.message });
        } else if (error instanceof TypeError) {
          reportError({ code: "network", message: error.message });
        }
      },
    }),
    defaultOptions: {
      queries: {
        retry: (failureCount, error) => {
          // Authorization and validation answers do not change on retry.
          const status = (error as { status?: number })?.status;
          if (status && status < 500) return false;
          return failureCount < 2;
        },
        staleTime: 10_000,
        refetchInterval: PAGE_REFRESH_MS,
        refetchIntervalInBackground: false,
        refetchOnWindowFocus: true,
      },
    },
  });
}
